var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 21") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Website-Copy",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solutions",
    transform: "translate(-652.000000, -9981.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21",
    transform: "translate(652.000000, 9981.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-43-Copy-5",
    fill: "#FAF6CE",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    rx: 19
  }), /*#__PURE__*/React.createElement("g", {
    id: "reshot-icon-restrooms-M6WD9CPQKH",
    transform: "translate(17.000000, 23.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.324216,17.8079875 C0.753624,17.075775 1.544472,16.625 2.4,16.625 L21.6,16.625 C22.4556,16.625 23.2464,17.075775 23.67576,17.8079875 C24.10512,18.5402 24.10824,19.443175 23.68368,20.1782375 L14.083776,36.8032375 C13.65648,37.5432875 12.861264,38 12,38 C11.138736,38 10.34352,37.5432875 9.916224,36.8032375 L0.316224,20.1782375 C-0.10824,19.443175 -0.105192,18.5402 0.324216,17.8079875 Z M6.535632,21.375 L12,30.83795 L17.464368,21.375 L6.535632,21.375 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,4.75 C10.674528,4.75 9.6,5.813335 9.6,7.125 C9.6,8.436665 10.674528,9.5 12,9.5 C13.325472,9.5 14.4,8.436665 14.4,7.125 C14.4,5.813335 13.325472,4.75 12,4.75 Z M4.8,7.125 C4.8,3.18998125 8.02356,0 12,0 C15.97644,0 19.2,3.18998125 19.2,7.125 C19.2,11.0600188 15.97644,14.25 12,14.25 C8.02356,14.25 4.8,11.0600188 4.8,7.125 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,4.75 C34.67448,4.75 33.6,5.813335 33.6,7.125 C33.6,8.436665 34.67448,9.5 36,9.5 C37.32552,9.5 38.4,8.436665 38.4,7.125 C38.4,5.813335 37.32552,4.75 36,4.75 Z M28.8,7.125 C28.8,3.18998125 32.02344,0 36,0 C39.97656,0 43.2,3.18998125 43.2,7.125 C43.2,11.0600188 39.97656,14.25 36,14.25 C32.02344,14.25 28.8,11.0600188 28.8,7.125 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,16.625 C36.86136,16.625 37.65648,17.0817125 38.08368,17.8217625 L47.68368,34.4467625 C48.10824,35.181825 48.10512,36.0848 47.67576,36.8170125 C47.2464,37.549225 46.4556,38 45.6,38 L26.4,38 C25.5444,38 24.7536,37.549225 24.32424,36.8170125 C23.89488,36.0848 23.89176,35.181825 24.31632,34.4467625 L33.91632,17.8217625 C34.34352,17.0817125 35.13864,16.625 36,16.625 Z M30.53568,33.25 L41.46432,33.25 L36,23.78705 L30.53568,33.25 Z",
    id: "Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/people-icon.e7dd56527bb42878845480023959a808.svg";
export { ForwardRef as ReactComponent };